import { Component, Inject, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EpicasBean } from 'src/app/shared/model/gestion-proyectos/epicas.model';
import swal from 'sweetalert2';
import { HucuService } from '../hucu.service';
import { Probabilidad } from 'src/app/shared/model/gestion-proyectos/riesgos/probabilidad.model';
import { ProyectosService } from 'src/app/proyectos/proyectos.service';
import { UrlConstantes } from 'src/app/utilerias/constantes/urlconstantes';
import { Impacto } from 'src/app/shared/model/gestion-proyectos/riesgos/impacto.model';
import { Constantes } from 'src/app/utilerias/constantes/constantes';
import { Msg } from 'src/app/utilerias/mensajes/Msg';
import { MatFormField, MatLabel, MatInput, MatSuffix } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { NgFor } from '@angular/common';
import { MatOption } from '@angular/material/autocomplete';
import { SoloNumeroDirective } from '../../utilerias/directives/solo-numero.directive';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-modal-epicas',
    templateUrl: './modal-epicas.component.html',
    styleUrls: ['./modal-epicas.component.css'],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatSelect, NgFor, MatOption, SoloNumeroDirective, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, MatButton]
})
export class ModalEpicasComponent {
  historias: FormGroup;
  objetoEpicas: EpicasBean;
  @Input() id_proyecto: string;
  @Input() datosCu: any;
  @Input() dialogRef: MatDialogRef<ModalEpicasComponent>;
  listaEpicas: Array<EpicasBean>;
  epicasGroup: FormGroup;
  prioridad: Probabilidad[] = [];
  riesgo: Impacto[] = [];
  minDateFin = new Date();

  constructor(
    private service: ProyectosService,
    private hucuService: HucuService, private formbuilder: FormBuilder, private msg: Msg,
    @Inject(MAT_DIALOG_DATA) public data: any

  ) { }

  ngOnInit() {
    this.obtenerProbabilidad();
    this.obtenerImpactos();
    if (this.datosCu != null) {
      this.objetoEpicas = this.datosCu;
      this.consultaEpicas(this.datosCu.id);
    } else {
      this.objetoEpicas = new EpicasBean();
    }
    this.inicializarFormulario();
  }

  inicializarFormulario(){
    this.epicasGroup = this.formbuilder.group({
      tituloCtrl: new FormControl( '' , Validators.required),
      descripcionCtrl: new FormControl('', Validators.required),
      prioridadCtrl: new FormControl('', Validators.required),
      riesgoCtrl: new FormControl('', Validators.required),
      esfuerzoCtrl: new FormControl('', Validators.required),
      valorNegocio: new FormControl('', Validators.required),
      fechaInicio: new FormControl('', Validators.required),
      fechaPlaneadaFin: new FormControl('', Validators.required),
      tiempoCritico: new FormControl('', Validators.required),
    });

    this.epicasGroup.get("fechaInicio").valueChanges.subscribe(valor => {
      if(valor){
        
        const fechaInicio = new Date(this.epicasGroup.get('fechaInicio').value);
        this.minDateFin.setDate(fechaInicio.getDate() + Constantes.UNO);
      }
      });
  }

  guardarEpica(): void {
    this.objetoEpicas.id_proyecto = this.id_proyecto;
    this.hucuService.guardarEpica(this.objetoEpicas).subscribe(
      (respuesta) => {
        swal.fire({
          text: 'Épica registrada exitosamente',
          buttonsStyling: false,
          customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger',
          },
          icon: 'success',

        }).then((result) => {
          this.dialogRef.close(true);
        });
      });
  }

  consultaEpicas(id: number) {
    this.hucuService.consultaEpica(id).subscribe(res => {
      this.listaEpicas = res.list;
      if (this.listaEpicas.length > 0) {
        this.objetoEpicas = this.listaEpicas[0];
      }
    });
  }

  obtenerProbabilidad() {
    this.service.consultaGeneral(UrlConstantes.consultaProbabilidad).subscribe(res => {
        if (res != null) {
            this.prioridad = res.list;
        }
    });
}

obtenerImpactos(){
  this.service.consultaGeneral(UrlConstantes.consultaImpactos).subscribe(res => {
      if (res != null){
          this.riesgo = res.list;
      }
  })
}

validarFechaInicio(fecha){
  const fechaValida = new Date(fecha.value);
  if(!this.validacionFinSemana(fechaValida)){
    this.epicasGroup.get("fechaInicio").setValue(null);
  }
}

validaFechaFin(fecha){
  const fechaValida = new Date(fecha.value)
  if(!this.validacionFinSemana(fechaValida)){
    this.epicasGroup.get("fechaPlaneadaFin").setValue(null);
  }
}

validacionFinSemana(fecha: any) {
  if(fecha.getDay() !== 0 && fecha.getDay() !== 6){
      return true;
  }else{
      this.msg.errorCall("No puedes seleccionar un fin de semana", null, null);
      return false;
  }
}

}
